import script from "./LuckyWheel.vue?vue&type=script&setup=true&lang=js"
export * from "./LuckyWheel.vue?vue&type=script&setup=true&lang=js"

import "./LuckyWheel.vue?vue&type=style&index=0&id=46a222dc&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a222dc"]])

export default __exports__